import React from 'react';
import { Box, Text } from '@opendoor/bricks/core';
import { ExternalLink } from 'platform/react-router';

/**
 * TODO: Add documentation
 *
 * component-test-check-ignore
 */
export const PhoneNumberPrivacyPolicy: React.FC = () => (
  <Box color="neutrals90" my={8}>
    <Text fontSize="s0" lineHeight="s00">
      By clicking “Confirm”, I consent to receive marketing calls and texts from Opendoor and its
      affiliates to the number provided, including by automated means. I may opt out at any time and
      consent is not a condition of purchase. Your information is protected by our{' '}
      <ExternalLink
        aria-label={null}
        analyticsName="privacy-policy"
        href="https://www.opendoor.com/privacy"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </ExternalLink>
      .
    </Text>
  </Box>
);
